import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=f11010ac&scoped=true&"
import script from "./Root.vue?vue&type=script&lang=js&"
export * from "./Root.vue?vue&type=script&lang=js&"
import style1 from "./Root.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11010ac",
  null
  
)

export default component.exports